export const getCssConditions = (setsPerLine: number, totalItems: number) => {
  if (setsPerLine === 1) {
    return `
      margin-left: 0;
      margin-right: 0;

      &:nth-child(${totalItems}) { 
        margin-bottom: 0;
      } 
    `;
  }
  let css = "";

  css += `
   &:nth-child(1) { 
     margin-left: 0; 
   } 
   &:nth-child(${totalItems}) { 
     margin-right: 0; 
   } 
`;

  for (let i = 0; i < totalItems; i++) {
    if (i > 0 && i % setsPerLine === 0) {
      css += `
         &:nth-child(${i}) { 
           margin-right: 0; 
         } 
         &:nth-child(${i + 1}) { 
           margin-left: 0; 
         } 
      `;
    }

    if (i < setsPerLine) {
      css += `
        &:nth-child(${i + 1}) { 
          margin-top: 0; 
        } 
      `;
    }
  }

  return css;
};
